export const bookingsHc = {
  firstCheckinSend: {
    badge: "Automation",
    title: "When is the arrival information sent?",
    desc: "Enable each event and decide <strong>when</strong> it is sent: when <strong>a guest</strong> completes their registration, or only when <strong>all</strong> the guests on the booking complete their registration.",
    loading: "Loading settings…",
    welcomeName: "Welcome message",
    welcomeSub: "The welcome message the guest receives right after completing their registration.",
    documentName: "Signed policies document",
    documentSub: "It is the document the guest signs during the registration process. We send it as a PDF so they have it on their WhatsApp or email.",
    timingIndividual: "When a guest completes their registration",
    timingAll: "When all the guests on the booking complete the registration",
    timingQuestion: "When is it sent?",
    eventOffNote: "This event will not be sent automatically.",
    infoBox: "Changes are saved automatically. The access key, when the accommodation has a smart lock, follows its own configuration.",
    loadError: "The settings could not be loaded.",
    saveError: "The settings could not be saved. Please try again.",
  },
  checkinProcess: {
    colEmail: "Email",
    colSendDate: "Sent date",
    colStatus: "Status",
    unspecified: "Not specified",
    complete: "Complete",
    pending: "Pending",
  },
  listBookings: {
    title: "Check-in list",
    subtitle: `Record of your guests' check-ins`,
    accommodation: "Accommodation",
    all: "All",
    from: "From",
    to: "To",
    search: "Search",
    today: "Today",
    noDate: "No date",
    clear: "Clear",
    exporting: "Exporting...",
    exportCheckins: "Export",
    ricevutaBtn: "Police receipt",
    ricevutaTitle: "Italian police receipt",
    ricevutaHint: "The official Alloggiati Web receipt with every check-in sent each day. One day downloads a PDF; several, a ZIP with one PDF per day (31 max).",
    ricevutaFrom: "From",
    ricevutaTo: "To",
    ricevutaAccount: "Police account",
    ricevutaDownload: "Download PDF",
    ricevutaDownloading: "Downloading…",
    ricevutaCancel: "Cancel",
    ricevutaError: "The receipt could not be downloaded.",
    noAccommodation: "No accommodation",
    noReservation: "No booking",
    travelerReport: "Traveler report (Mossos)",
    noRecords: "No records",
    noRecordsFiltered: "No records were found with the applied filters.",
    noCheckinsTitle: "No check-ins registered yet",
    noCheckinsSub: `When your guests complete their check-in, you'll see them here with all their information.`,
    excelSuccess: "Check-ins downloaded to Excel",
    excelSuccessTitle: "Export completed",
    excelError: `We couldn't export the check-ins`,
    errorTitle: "Error",
    listingNotIdentified: "The check-in listing could not be identified",
    comprobanteNotAvailable: "The receipt is not yet available for this check-in",
    comprobanteDownloadError: "The receipt could not be downloaded",
  },
  modalFirstCheckin: {
    loading: "Loading...",
    sendingLinkWait: "Sending the check-in link, please wait...",
    phoneRequired: "To continue, you must enter the WhatsApp number",
    sendingLink: "Sending link ...",
    almostThere: "Almost there, please wait...",
    sentSuccess: "Sent successfully",
    sendError: "Error sending the check-in",
    title: "Try a check-in process now with your own phone",
    enterWhatsapp: "Enter your WhatsApp number",
    invalidNumber: `Invalid number. Make sure to include the "+" prefix.`,
    skip: "Skip",
    sendFirstCheckin: "Send your first check-in",
    sendCheckin: "Send check-in",
  },
  tableRetriveCheckinPending: {
    colEmail: "Email",
    colSendDate: "Sent date",
    colStatus: "Status",
    unspecified: "Not specified",
    complete: "Complete",
    pending: "Pending",
    emptyMessage: `You don't have any check-ins in progress yet`,
  },
  rerservationModal: {
    night: "night",
    nights: "nights",
    minStayBanner: "The selected range has a minimum stay restriction of {count} {nights} (OTA rule). Selected nights: {selected}.",
    freeUnits: "Available units: {count}",
    noAvailabilityDetailed: "No availability for these dates. {details}",
    noAvailability: "No availability for these dates.",
    hotelAvailabilityError: "The availability could not be validated (hotel).",
    minStayWarning: "A minimum of {count} nights is required for the arrival day. You have selected {selected}.",
    notEnoughAvailability: "There is not enough availability. Available units: {count}.",
    noAvailabilityDates: "There is no availability for the selected dates.",
    departureAfterArrival: "The departure must be after the arrival.",
    close: "Close",
    noMatches: "No matches",
    noAccommodations: "There are no accommodations",
    searchingGuests: "Searching guests...",
    noName: "No name",
    priceLocked: "The booking price cannot be modified.",
    otaMoveHint: "You can move it to another accommodation in the same listing; the channel is notified.",
    otaMoveHintCuenta: "You can move it to any of your accommodations. If it's in the same listing, the channel is notified.",
    otaRelocateNote: "This is another listing: it moves in WACheckin, but the channel will keep it in the accommodation where it was sold. Its changes and cancellation will still reach you.",
    extrasTitle: "Other options",
    extrasSub: "Tick what you charge and the discount you apply",
    quoteTitle: "What your direct booking charges",
    quoteHint: "Tick what you want to charge on this booking. The nights are always included.",
    quoteOptions: "1 to tick | {count} to tick",
    quoteNoExtras: "This accommodation has no cleaning fee or charges set up in its direct booking.",
    quoteStay: "Stay · {count} night | Stay · {count} nights",
    quoteExtraGuest: "Extra guest | {count} extra guests",
    quoteDiscount: "Discounts and promotions",
    quoteOccupancyDiscount: "Occupancy discount",
    quoteCleaning: "Cleaning fee",
    quoteTotal: "Total",
    quoteUse: "Use this price",
    quoteNoRate: "No rate for those dates: type the price yourself.",
    quoteLinePrice: "Price for this accommodation",
    unitsAdd: "Add another accommodation from the listing…",
    unitsGuests: "Guests in this accommodation",
    unitsRemove: "Remove from the booking",
    unitsGroupError: "The multi-accommodation booking could not be created.",
    resendTitle: "Resend confirmation message",
    resendSub: "Resends the confirmation template to the guest.",
    resendNote: "When you modify the booking, <strong>the confirmation template will be resent</strong> for this booking.",
    saving: "Saving...",
  },
};
